<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="addProductConfig.isOpen"
    id="add-sidebar"
  >
    <div class="flex items-center justify-between px-6 pb-2">
      <h4 class="font-bold text-2xl">Add New Product</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebarProduct" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="sidebar-content p-6 overflow-auto add-service-form">
        <h4 class="font-bold text-lg mb-3">Product name</h4>
        <vs-input placeholder="Product Name" v-validate="'required'" name="name" v-model="name" class="w-full" :danger="errors.has('name')"
              danger-text="The product name field is required"/>
        <h4 class="font-bold text-lg mb-3 mt-4">Product description</h4>
        <vs-textarea v-model="note" height="70"/>
        <h4 class="font-bold text-lg mb-3">Product price</h4>
        <vs-input v-model="price" v-on:keypress="isNumber($event)" icon="attach_money" class="w-full mb-5" :clearable="false" :searchable="false" :maxlength="9" :disabled="leave_blank"/>
        <div class="flex align-center"><vs-checkbox class="m-0 mr-2 mb-6" v-model="leave_blank">Leave blank</vs-checkbox></div>
        <!-- <vs-row>
          <vs-col vs-w="6" class="pr-3 service-price">
            <v-select v-model="selectedPrice" :options="prices" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" :clearable="false" :searchable="false"/><br>
          </vs-col>
          <vs-col vs-w="6" class="pl-3">
            <div v-if="selectedPrice.id === 2">
              <vs-input v-model="price" v-on:keypress="isNumber($event)" icon="attach_money" class="w-full" :clearable="false" :searchable="false" :maxlength="9"/>
            </div>
          </vs-col>
        </vs-row> -->
        <h4 class="font-bold text-lg mb-4">Category name</h4>
        <v-select @input="selectId($event)" label="name" :options="serviceData" v-model="cateId" class="w-full" disabled :clearable="false" :searchable="false"></v-select>
        <h4 class="font-bold text-lg mb-6 mt-4">Online booking visibility</h4>
        <div class="flex align-center"><vs-checkbox class="m-0 mr-2" v-model="status">Service visible to client during online booking.</vs-checkbox></div>
        <p class="text-grey-custom" style="font-size: 12px">When enabled, this service will appear in your Booking Site and Embedded Widgets. This will not affect your ability to choose it when you create an appointment.</p>
        <p v-if="config.service_distinction">
        <vs-checkbox class="m-0 mr-2 mb-6" v-model="gocheckin_available">Service available on GoCheckin.</vs-checkbox>
        </p>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click="submitData" style="min-width: 140px">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeSidebarProduct" style="min-width: 140px">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: "vs-add-product",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    'v-select': vSelect,
  },
  props: {
    isActive: { type: Boolean },
    addProductConfig: {
      type: Object,
      required: true
    },
    serviceData: {
      type: Array,
      required: false
    },
    activeServiceData: {
      type: Object,
      required: true
    },
    activeStaffData: {
      type: Object,
      required: true,
    }
  },
  data() {
      return {
          number0: 0,
          status: true,
          name :"",
          cateId: this.activeStaffData.name,
          selectedId: this.activeStaffData.id,
          note:"",
          price: '',
          hours: [
            {label: '0 hrs' , value: '0'},{label: '1 hrs' , value: '1'},{label: '2 hrs' , value: '2'},{label: '3 hrs' , value: '3'},
            {label: '4 hrs' , value: '4'},{label: '5 hrs' , value: '5'},{label: '6 hrs' , value: '6'},{label: '7 hrs' , value: '7'},
            {label: '8 hrs' , value: '8'},{label: '9 hrs' , value: '9'},{label: '10 hrs' , value: '10'},{label: '11 hrs' , value: '11'},
            {label: '12 hrs' , value: '12'},{label: '13 hrs' , value: '13'},{label: '14 hrs' , value: '14'},
          ],
          selectedHour: {label: '0 hrs' , value: '0'},
          minutes: [
            {label: '0 mins' , value: '0'},{label: '5 mins' , value: '5'},{label: '10 mins' , value: '10'},{label: '15 mins' , value: '15'},
            {label: '20 mins' , value: '20'},{label: '25 mins' , value: '25'},{label: '30 mins' , value: '30'},{label: '35 mins' , value: '35'},
            {label: '40 mins' , value: '40'},{label: '45 mins' , value: '45'},{label: '50 mins' , value: '50'},{label: '55 mins' , value: '55'},
          ],
          selectedMinute: {label: '0 mins' , value: '0'},
          prices: [
            {id:1, label: 'Leave blank'},
            {id:2, label: 'Add price'}
          ],
          selectedPrice:{id:1,label: 'Leave blank'},
          id: null,
          has_err: false,
          distinctionSelect: [
            {name: "Show on GoCheckin & GoBooking", value: 0, },
            {name: "Show only on GoCheckin", value: 1, },
            {name: "Show only on GoBooking", value: 2, },
          ],
          distinctionValue: {name: "Show on GoCheckin & GoBooking", value: 0, },
          gocheckin_available: true,
          gobooking_available: true,
          leave_blank: true
      }
  },
  watch: {
    addProductConfig: {
      immediate: true,
      deep: true,
      handler() {
        // this.name = '';
        // this.errors = [];
        this.errors.clear();
        if(this.addProductConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
          if(this.activeStaffData){
            this.cateId  =  this.activeStaffData.name;
            this.selectedId = this.activeStaffData.id;
          }
        } else {
          document.body.classList.remove('overflow-hidden');
          this.name = '';
          if(this.activeStaffData){
            this.cateId  =  this.activeStaffData.name;
            this.selectedId = this.activeStaffData.id;
          }
          this.has_err = false;
          this.note = "";
          this.status = true;
          this.price = '';
          this.selectedHour = {label: '0 hrs' , value: '0'};
          this.selectedMinute = {label: '0 mins' , value: '0'};
          this.gocheckin_available = true;
          this.gobooking_available = true;
          this.leave_blank = true;
        }
      }
    },
    id: {
      immediate: true,
      handler() {
        if(this.id != null) {
          this.has_err = false;
        }
      }
    }
  },
  computed:{
    service_cateId: {
        get() {
          return this.cateId;
        },
        set(value) {
          this.cateId = value;
        }
    },
    config(){
      return this.$store.getters['auth/config'];
    }
  },
  methods: {
     isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.price.indexOf(".") != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    selectId(e) {
      this.selectedId = e.id
    },
    closeSidebarProduct() {
      this.$emit("CloseSidebarProduct");
    },
    submitData(){
      if(this.selectedId == null){
        this.selectedId = '';
      }
      let group_id = "both";
      if (this.gocheckin_available == true && this.gobooking_available == false){
        group_id = 1;
      } else if (this.gocheckin_available == false && this.gobooking_available == true){
        group_id = 2;
      }
      if(this.name != ''){
        const obj = {
        name: this.name,
        category_id: (this.selectedId != 999999) ? this.selectedId : '',
        cate_name: this.cateId,
        id: (this.selectedId != 999999) ? this.selectedId : '',
        web_booking_visible: this.status ? 1 : 0,
        // price: this.price == '' ? '' : parseFloat(this.price),
        price: this.leave_blank || this.price == '' ? '' : parseFloat(this.price),
        description: this.note,
        // duration: parseInt(this.selectedHour.value*60) + parseInt(this.selectedMinute.value),
        group_id,
        status: 1
      }
        this.$emit("AddProduct" , obj);
        this.closeSidebarProduct();
      }
      if(this.id == null) {
        this.has_err = true;
      }
      this.$validator.validateAll();
    },
  }
};
</script>
